export default "__VITE_ASSET__BQPbjQ6O__"